import type { FC, FormEventHandler } from 'react';
import { useTranslation } from 'react-i18next';

export interface SavedReportFormState {
  name: string;
  filters: string;
  columns: string;
}

export interface SavedReport {
  id: number;
  name: string;
  query_json: string;
}

export interface ReportsPageProps {
  form: SavedReportFormState;
  onFormChange: (next: SavedReportFormState) => void;
  reports: SavedReport[];
  isSubmitting: boolean;
  onSubmit: FormEventHandler<HTMLFormElement>;
}

const ReportsPage: FC<ReportsPageProps> = ({ form, onFormChange, reports, isSubmitting, onSubmit }) => {
  const { t } = useTranslation();

  return (
    <form className="card" onSubmit={onSubmit}>
      <h2>{t('savedReports')}</h2>
      <label>
        {t('reportName')}
        <input
          value={form.name}
          onChange={(event) => onFormChange({ ...form, name: event.target.value })}
        />
      </label>
      <label>
        {t('reportFiltersJson')}
        <textarea
          rows={3}
          value={form.filters}
          onChange={(event) => onFormChange({ ...form, filters: event.target.value })}
        />
      </label>
      <label>
        {t('reportColumns')}
        <input
          value={form.columns}
          onChange={(event) => onFormChange({ ...form, columns: event.target.value })}
        />
      </label>
      <button type="submit" disabled={isSubmitting}>
        {isSubmitting ? t('saving') : t('saveReport')}
      </button>
      {reports.length ? (
        <ul className="list compact-list">
          {reports.map((report) => (
            <li key={report.id}>
              <div>
                <strong>{report.name}</strong>
                <span>{report.query_json}</span>
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <p>{t('noSavedReports')}</p>
      )}
    </form>
  );
};

export default ReportsPage;
